import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminContext = createContext(null);

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('adminToken'));
  const [email, setEmail] = useState(localStorage.getItem('adminEmail'));
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          await axios.get(`${API}/admin/verify?token=${token}`);
          setIsAuthenticated(true);
        } catch (error) {
          logout();
        }
      }
      setLoading(false);
    };
    verifyToken();
  }, [token]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/admin/login`, { email, password });
    const { token: newToken, email: userEmail } = response.data;
    localStorage.setItem('adminToken', newToken);
    localStorage.setItem('adminEmail', userEmail);
    setToken(newToken);
    setEmail(userEmail);
    setIsAuthenticated(true);
    return response.data;
  };

  const logout = () => {
    if (token) {
      axios.post(`${API}/admin/logout?token=${token}`).catch(() => {});
    }
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminEmail');
    setToken(null);
    setEmail(null);
    setIsAuthenticated(false);
  };

  return (
    <AdminContext.Provider value={{ token, email, isAuthenticated, loading, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};
